import {cx} from "emotion";
import * as React from "react";

import "./aspect-ratio-control.scss";

import {cs}        from "@Common/react/chain-services";
import {keyed}     from "@Common/react/keyed";
import {equalDeep} from "@Common/utils/objects";

import {CustomRatioSvg} from "./custom-ratio-svg";
import {Ratio11Svg}     from "./ratio-1-1-svg";
import {Ratio23Svg}     from "./ratio-2-3-svg";
import {Ratio34Svg}     from "./ratio-3-4-svg";

export const AspectRatioControl = ({mobile, state}) => (
    <div className={cx("aspect-ratio-control aspect-ratio-control-4fr", {mobile})}>
        {aspectRatios.map(({ratio, icon},i) => cs(
            keyed(i),
            ["label", (_, next) => next(
                ratio ? (
                    `${ratio.width}:${ratio.height}`
                ) : (
                    "Custom"
                )
            )],
            ({label}) => (
                <button {...{
                    className: cx({active: equalDeep(ratio, state.value), mobile}),
                    onClick: () => state.onChange(ratio),

                    "xd-qa-type": "button",
                    "xd-qa-name": label,
                }}>
                    <div className="label">
                        {label}
                    </div>

                    <div className="icon">
                        {icon({})}
                    </div>
                </button>
            ),
        ))}
    </div>
);

const aspectRatios = [
    {
        ratio: {width: 2, height: 3},
        icon: Ratio23Svg,
    },
    {
        ratio: {width: 3, height: 4},
        icon: Ratio34Svg,
    },
    {
        ratio: {width: 1, height: 1},
        icon: Ratio11Svg,
    },
    {
        ratio: null,
        icon: CustomRatioSvg,
    },
];
